<template>
    <div class="w-full">
        <div class="w-full xl:w-1/2 mx-auto">
            <div class="w-full h-64 mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    Tahap 2 - Pemesanan <br />
                    BPJS
                </h1>
                <!-- Data Pasien -->
                <PasienCard :pasien="pasien" />
            </div>
            <!-- Form -->
            <div class="w-full mt-64 md:mt-52">
                <h1 class="text-center text-slate-700 font-bold mt-5">
                    PENDAFTARAN POLIKLINIK
                </h1>
                <form @submit.prevent="regis">
                    <div class="w-full mt-2">
                        <TextInput
                            v-model="form.nik"
                            :error="form.errors.nik"
                            class="w-full"
                            id="nik"
                            label="NIK"
                            type="text"
                        />
                    </div>
                    <div class="w-full mt-5">
                        <TextInput
                            v-model="form.no_hp"
                            :error="form.errors.no_hp"
                            class="w-full"
                            id="no_hp"
                            label="NO HP"
                            type="text"
                        />
                    </div>
                    <div class="w-full mt-5">
                        <SelectInput
                            v-model="form.penjamin"
                            :error="form.errors.penjamin"
                            id="penjamin"
                            label="Penjamin"
                        >
                            <option value="">=== PILIH PENJAMIN ===</option>
                            <option value="JKN01">BPJS PBI</option>
                            <option value="JKN02">BPJS NON PBI</option>
                        </SelectInput>
                    </div>
                    <div class="flex w-full mt-5">
                        <TextInput
                            v-model="form.no_peserta"
                            :error="form.errors.no_peserta"
                            :custError="
                                $page.props.errors.checkPeserta
                                    ? $page.props.errors.checkPeserta.no_peserta
                                    : ''
                            "
                            :disabled="activeNoPeserta == 1"
                            class="w-3/6 md:grow md:mr-5"
                            id="no_peserta"
                            label="Nomor Kartu BPJS"
                            type="text"
                        />
                        <button
                            v-if="activeNoPeserta == 0"
                            @click.prevent="checkPeserta"
                            class="bg-slate-200 w-36 rounded-xl text-center h-10 flex items-center p-5 box-border ml-auto self-end text-sm hover:bg-slate-500 hover:text-white justify-center"
                        >
                            CEK
                        </button>
                        <button
                            v-if="activeNoPeserta == 1"
                            @click.prevent="resetPeserta"
                            class="bg-red-200 w-36 rounded-xl text-center h-10 flex items-center p-5 box-border ml-auto self-end text-sm hover:bg-red-500 hover:text-white justify-center"
                        >
                            UBAH
                        </button>
                    </div>
                    <div v-if="peserta" class="w-full mt-2">
                        <div
                            v-if="peserta.statusPeserta == '000'"
                            class="w-full h-14 flex items-center bg-green-600 p-2 rounded-lg text-white"
                        >
                            PESERTA AKTIF
                        </div>
                        <div
                            v-if="peserta.statusPeserta == '999'"
                            class="w-full h-14 flex items-center bg-red-600 p-2 rounded-lg text-white"
                        >
                            {{ peserta.statusPesertaMsg }}
                        </div>
                    </div>
                    <div v-if="listRujukanInternalByPeserta">
                        <div
                            class="border border-solid border-black p-3 rounded-lg mt-5"
                        >
                            <p class="text-lg text-center mt-2 mb-5">
                                DATA RUJUKAN INTERNAL
                            </p>
                            <div
                                v-for="(
                                    {
                                        FS_NO_SURAT,
                                        FD_TGL_PERIKSA,
                                        layanan_asal,
                                        layanan_tujuan,
                                    },
                                    index
                                ) in listRujukanInternalByPeserta"
                                :key="FS_NO_SURAT"
                                class="w-full bg-green-300 h-80 rounded-lg p-5 mb-5"
                            >
                                <table width="100%">
                                    <tr>
                                        <td colspan="2" class="text-center">
                                            NO SURAT
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="font-bold text-center"
                                            colspan="2"
                                        >
                                            {{ FS_NO_SURAT }}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>TANGGAL PERIKSA</td>
                                        <td class="font-bold text-right">
                                            {{ FD_TGL_PERIKSA }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>POLI ASAL</td>
                                        <td class="font-bold text-right">
                                            {{ layanan_asal.FS_NM_LAYANAN }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>POLI TUJUAN</td>
                                        <td class="font-bold text-right">
                                            {{ layanan_tujuan.FS_NM_LAYANAN }}
                                        </td>
                                    </tr>
                                </table>
                                <button
                                    @click.prevent="setRujukanInternal(index)"
                                    class="btn-green ml-auto w-36 h-10 float-right mt-5"
                                >
                                    Pilih
                                </button>
                                <div class="clear-both"></div>
                            </div>
                            <div
                                class="w-full bg-green-300 h-48 rounded-lg p-5 mt-5"
                            >
                                <h1
                                    class="font-bold text-2xl text-black text-center"
                                >
                                    RUJUKAN INTERNAL DIPILIH
                                </h1>
                                <h1 class="font-bold text-xl text-black mt-5">
                                    {{
                                        rujukanInternalSelected
                                            ? rujukanInternalSelected.FS_NO_SURAT
                                            : ""
                                    }}
                                </h1>
                                <button
                                    v-if="rujukanInternalSelected"
                                    @click.prevent="resetRujukanInternal()"
                                    class="btn-red ml-auto w-36 h-10 mt-5"
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="listSuratKontrolByPeserta">
                        <div
                            class="border border-solid border-black p-3 rounded-lg mt-5"
                        >
                            <p class="text-lg text-center mt-2 mb-5">
                                DATA SURAT KONTROL (RUJUKAN LAMA)
                            </p>
                            <div
                                v-for="(
                                    suratKontrol,
                                    index
                                ) in listSuratKontrolByPeserta"
                                :key="suratKontrol.noSuratKontrol"
                                class="w-full bg-green-300 h-80 rounded-lg p-5 mb-5"
                            >
                                <table width="100%">
                                    <tr>
                                        <td colspan="2" class="text-center">
                                            NO SURAT KONTROL
                                            <span class="font-bold">
                                                {{
                                                    suratKontrol.dataSuratKontrolDetail.sep
                                                        .jnsPelayanan ===
                                                    "Rawat Jalan"
                                                        ? "POST RAJAL"
                                                        : "POST RANAP"
                                                }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="font-bold text-center"
                                            colspan="2"
                                        >
                                            {{ suratKontrol.noSuratKontrol }}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td class="text-sm">TANGGAL KONTROL</td>
                                        <td class="font-bold text-right text-sm">
                                            {{ suratKontrol.tglRencanaKontrol }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-sm">SEP</td>
                                        <td class="font-bold text-right text-sm">
                                            {{ suratKontrol.noSepAsalKontrol }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-sm">LAYANAN ASAL</td>
                                        <td class="font-bold text-right text-sm">
                                            {{ suratKontrol.namaPoliAsal }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-sm">POLI TUJUAN</td>
                                        <td class="font-bold text-right text-sm">
                                            {{ suratKontrol.namaPoliTujuan }}
                                        </td>
                                    </tr>
                                </table>
                                <button
                                    @click.prevent="setSuratKontrol(index)"
                                    class="btn-green ml-auto w-36 h-10 float-right mt-5"
                                >
                                    Pilih
                                </button>
                                <div class="clear-both"></div>
                            </div>
                            <div
                                class="w-full bg-green-300 h-48 rounded-lg p-5 mt-5"
                            >
                                <h1
                                    class="font-bold text-2xl text-black text-center"
                                >
                                    SURAT KONTROL DIPILIH
                                </h1>
                                <h1 class="font-bold text-xl text-black mt-5">
                                    {{
                                        suratKontrolSelected
                                            ? suratKontrolSelected.noSuratKontrol
                                            : ""
                                    }}
                                </h1>
                                <button
                                    v-if="suratKontrolSelected"
                                    @click.prevent="resetSuratKontrol()"
                                    class="btn-red ml-auto w-36 h-10 mt-5"
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="listRujukanByPeserta">
                        <div
                            class="border border-solid border-black p-3 rounded-lg mt-5"
                        >
                            <p class="text-lg text-center mt-2 mb-5">
                                DATA RUJUKAN (RUJUKAN BARU)
                            </p>
                            <div
                                v-for="(
                                    {
                                        noKunjungan,
                                        tglKunjungan,
                                        provPerujuk,
                                        diagnosa,
                                        poliRujukan,
                                    },
                                    index
                                ) in listRujukanByPeserta"
                                :key="noKunjungan"
                                class="w-full bg-green-300 h-80 rounded-lg p-5 mb-5"
                            >
                                <table width="100%">
                                    <tr>
                                        <td>NO RUJUKAN</td>
                                        <td class="font-bold text-right">
                                            {{ noKunjungan }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>TANGGAL KUNJUNGAN</td>
                                        <td class="font-bold text-right">
                                            {{ tglKunjungan }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>FASKES PERUJUK</td>
                                        <td class="font-bold text-right">
                                            {{ provPerujuk.nama }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>DIAGNOSA</td>
                                        <td class="font-bold text-right">
                                            {{ diagnosa.nama }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>POLI TUJUAN</td>
                                        <td class="font-bold text-right">
                                            {{ poliRujukan.nama }}
                                        </td>
                                    </tr>
                                </table>
                                <button
                                    @click.prevent="setRujukan(index)"
                                    class="btn-green ml-auto w-36 h-10 float-right mt-5"
                                >
                                    Pilih
                                </button>
                                <div class="clear-both"></div>
                            </div>
                            <div
                                class="w-full bg-green-300 h-48 rounded-lg p-5 mt-5"
                            >
                                <h1
                                    class="font-bold text-2xl text-black text-center"
                                >
                                    RUJUKAN BARU DIPILIH
                                </h1>
                                <h1 class="font-bold text-xl text-black mt-5">
                                    {{
                                        rujukanSelected
                                            ? rujukanSelected.noKunjungan
                                            : ""
                                    }}
                                </h1>
                                <button
                                    v-if="rujukanSelected"
                                    @click.prevent="resetRujukan()"
                                    class="btn-red ml-auto w-36 h-10 mt-5"
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="activeNoPeserta == 1 && activeNoRujukan == 1">
                        <SelectInput
                            v-model="form.tipe_rujukan"
                            :error="form.errors.tipe_rujukan"
                            id="tipe_rujukan"
                            class="mt-2"
                            label="Tipe Rujukan"
                            :disabled="true"
                        >
                            <option value="">=== PILIH TIPE RUJUKAN ===</option>
                            <option value="01">RUJUKAN BARU</option>
                            <option value="02">RUJUKAN LAMA/KONTROL</option>
                            <option value="03">RUJUKAN INTERNAL</option>
                            <option value="04">RUJUKAN FISIOTERAPI</option>
                            <option value="05">
                                RUJUKAN KONTROL SETELAH RAWAT INAP
                            </option>
                        </SelectInput>
                        <div v-if="checkValidationSucces()">
                            <div class="w-full mt-5">
                                <SelectInput
                                    v-model="form.poli"
                                    :error="form.errors.poli"
                                    :custError="
                                        $page.props.errors.getDokter
                                            ? $page.props.errors.getDokter.poli
                                            : ''
                                    "
                                    id="poli"
                                    label="poli"
                                >
                                    <option value="">=== PILIH POLI ===</option>
                                    <option
                                        v-for="poli in poliList"
                                        :key="poli.FS_KD_LAYANAN"
                                        :value="poli.FS_KD_LAYANAN"
                                    >
                                        {{ poli.FS_NM_LAYANAN }}
                                    </option>
                                </SelectInput>
                            </div>
                            <div class="w-full mt-5 flex">
                                <DateInput
                                    v-model="form.tgl_periksa"
                                    :error="form.errors.tgl_periksa"
                                    :custError="
                                        $page.props.errors.getDokter
                                            ? $page.props.errors.getDokter
                                                  .tgl_periksa
                                            : ''
                                    "
                                    class="w-full grow mr-5"
                                    id="tgl_periksa"
                                    label="PILIH TANGGAL"
                                    :disabled="disableTglPeriksa"
                                />
                                <button
                                    @click.prevent="getDokter"
                                    class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs"
                                >
                                    LIHAT DOKTER
                                </button>
                            </div>
                            <div v-if="jadwalDokter">
                                <div
                                    v-if="
                                        jadwalDokter.statusJadwalDokter == '000'
                                    "
                                    class="border border-solid border-black p-3 rounded-lg mt-5"
                                >
                                    <p class="text-lg text-center mt-2 mb-5">
                                        DATA DOKTER
                                    </p>
                                    <div
                                        v-for="jadwalDokter in jadwalDokter.jadwalDokterRes"
                                        :key="jadwalDokter.kode_dokter"
                                        class="w-full bg-green-300 h-40 rounded-lg p-5 mt-5"
                                    >
                                        <h1
                                            class="font-bold text-2xl text-black"
                                        >
                                            {{ jadwalDokter.nama_dokter }}
                                        </h1>
                                        <p
                                            class="font-semibold text-xl text-purple-800 mt-5"
                                        >
                                            {{ jadwalDokter.jam_praktik }}
                                        </p>

                                        <button
                                            @click.prevent="
                                                setDokter(
                                                    jadwalDokter.kode_dokter,
                                                    jadwalDokter.nama_dokter,
                                                    jadwalDokter.jam_praktik
                                                )
                                            "
                                            class="btn-green ml-auto w-36 h-10"
                                        >
                                            Pilih
                                        </button>
                                    </div>
                                    <div
                                        class="w-full bg-green-300 h-48 rounded-lg p-5 mt-5"
                                    >
                                        <h1
                                            class="font-bold text-2xl text-black text-center"
                                        >
                                            DOKTER DIPILIH
                                        </h1>
                                        <h1
                                            class="font-bold text-xl text-black mt-5"
                                        >
                                            {{
                                                dokterSelected
                                                    ? dokterSelected.nama_dokter
                                                    : ""
                                            }}
                                        </h1>
                                        <p
                                            class="font-semibold text-xl text-purple-800 mt-2"
                                        >
                                            {{
                                                dokterSelected
                                                    ? dokterSelected.jam_praktik
                                                    : ""
                                            }}
                                        </p>

                                        <button
                                            v-if="dokterSelected"
                                            @click.prevent="resetDokter()"
                                            class="btn-red ml-auto w-36 h-10"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                    <div
                                        v-if="form.errors.dokter"
                                        class="mt-2 text-red-500 h-8"
                                    >
                                        {{ form.errors.dokter }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="jadwalDokter" class="w-full mt-2">
                                <div
                                    v-if="
                                        jadwalDokter.statusJadwalDokter == '999'
                                    "
                                    class="w-full h-14 flex items-center bg-red-600 p-2 rounded-lg text-white"
                                >
                                    {{ jadwalDokter.statusJadwalDokterMsg }}
                                </div>
                            </div>
                        </div>
                        <FlashMessage class="mt-5" />
                        <div class="w-full mt-5">
                            <button
                                type="submit"
                                class="bg-teal-400 hover:bg-teal-700 h-16 rounded-3xl mt-8 w-full text-white m-auto"
                            >
                                DAFTAR
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import LayoutNoHeader from "../../Shared/LayoutNoHeader.vue";
import TextInput from "../../Shared/TextInput.vue";
import DateInput from "../../Shared/DateInput.vue";
import SelectInput from "../../Shared/SelectInput.vue";
import FlashMessage from "../../Shared/FlashMessage.vue";
import PasienCard from "../../Shared/PasienCard.vue";
import RujukanCard from "../../Shared/RujukanCard.vue";
import SuratKontrolCard from "../../Shared/SuratKontrolCard.vue";

export default {
    props: {
        pasien: Object,
        polis: Object,
    },
    components: {
        TextInput,
        DateInput,
        SelectInput,
        FlashMessage,
        PasienCard,
        RujukanCard,
        SuratKontrolCard,
    },
    layout: LayoutNoHeader,
    data() {
        return {
            form: this.$inertia.form({
                no_rm: this.pasien.FS_MR,
                no_peserta: this.pasien.peserta
                    ? this.pasien.peserta.FS_KD_PESERTA
                    : "",
                no_surat_internal: "",
                no_surat_kontrol: "",
                no_rujukan: "",
                penjamin: this.pasien.peserta
                    ? this.pasien.peserta.tipe_jaminan
                        ? this.pasien.peserta.tipe_jaminan.FS_KD_TIPE_JAMINAN
                        : ""
                    : "",
                nik: this.pasien.FS_KD_IDENTITAS,
                no_hp: this.pasien.FS_TLP_PASIEN,
                poli: "",
                tgl_periksa: "",
                dokter: "",
                tipe_rujukan: "",
                rujukan_detail: "",
                surat_kontrol_detail: "",
            }),
            listRujukanInternalByPeserta: "",
            listSuratKontrolByPeserta: "",
            listRujukanByPeserta: "",
            dokterSelected: "",
            suratKontrolSelected: "",
            jadwalDokter: "",
            peserta: "",
            rujukan: "",
            suratKontrol: "",
            activeNoPeserta: 0,
            activeNoRujukan: 0,
            activeNoSuratKontrol: 0,
            poliList: this.polis,
            disableTglPeriksa: false,
        };
    },
    computed: {
        formPoli() {
            return this.form.poli;
        },
        formTglPeriksa() {
            return this.form.tgl_periksa;
        },
    },
    watch: {
        formPoli() {
            this.resetJadwalDokter();
        },
        formTglPeriksa() {
            this.resetJadwalDokter();
        },
    },
    methods: {
        regis() {
            const confirm = window.confirm(
                "Pastikkan data sudah benar, Yakin Anda akan menyimpan data booking tersebut?"
            );
            if (confirm == 1) {
                this.form.post("/bpjs_regis", { preserveScroll: true });
            }
        },
        checkPeserta() {
            this.$inertia.post(
                "/bpjs/peserta",
                {
                    no_peserta: this.form.no_peserta,
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.peserta = page.props.additional.peserta;
                        if (this.peserta) {
                            if (this.peserta.statusPeserta == "000") {
                                this.activeNoPeserta = 1;
                                this.listRujukanInternalByPeserta =
                                    this.peserta.listRujukanInternalByPeserta;
                                this.listSuratKontrolByPeserta =
                                    this.peserta.listSuratKontrolByPeserta;
                                this.listRujukanByPeserta =
                                    this.peserta.listRujukanByPeserta;
                            } else {
                                this.activeNoPeserta = 0;
                            }
                        }
                    },
                    errorBag: "checkPeserta",
                }
            );
        },
        checkValidationSucces() {
            if (
                this.form.tipe_rujukan == "01" &&
                this.activeNoPeserta == 1 &&
                this.activeNoRujukan == 1
            ) {
                return true;
            } else if (
                this.form.tipe_rujukan == "02" &&
                this.activeNoPeserta == 1 &&
                this.activeNoRujukan == 1 &&
                this.activeNoSuratKontrol == 1
            ) {
                return true;
            } else if (
                this.form.tipe_rujukan == "03" &&
                this.activeNoPeserta == 1 &&
                this.activeNoRujukan == 1
            ) {
                return true;
            } else if (
                this.form.tipe_rujukan == "04" &&
                this.activeNoPeserta == 1 &&
                this.activeNoRujukan == 1
            ) {
                return true;
            } else if (
                this.form.tipe_rujukan == "05" &&
                this.activeNoPeserta == 1 &&
                this.activeNoRujukan == 1 &&
                this.activeNoSuratKontrol == 1
            ) {
                return true;
            } else {
                return false;
            }
        },
        getDokter() {
            this.resetDokter();
            this.$inertia.post(
                "/jadwal_dokter",
                {
                    poli: this.form.poli,
                    tgl_periksa: this.form.tgl_periksa,
                },
                {
                    preserveScroll: true,
                    onSuccess: (page) => {
                        this.jadwalDokter = page.props.additional.jadwalDokter;
                    },
                    errorBag: "getDokter",
                }
            );
        },
        resetJadwalDokter() {
            this.resetDokter();
            this.jadwalDokter = "";
        },
        setDokter(kdDokter, nmDokter, jmPraktik) {
            this.form.dokter = kdDokter;
            this.dokterSelected = {
                nama_dokter: nmDokter,
                jam_praktik: jmPraktik,
            };
        },
        resetDokter() {
            this.form.dokter = "";
            this.dokterSelected = "";
        },
        resetPeserta() {
            this.form.no_peserta_nik = "";
            this.peserta = "";
            this.activeNoPeserta = 0;
            this.listRujukanInternalByPeserta = "";
            this.listSuratKontrolByPeserta = "";
            this.listRujukanByPeserta = "";
        },
        // Rujukan Internal
        setRujukanInternal(index) {
            if(this.form.tipe_rujukan != ""){
                const tipeRujukan = this.getTipeRujukanById(this.form.tipe_rujukan);
                alert(
                    `Reset ${tipeRujukan} Terlebih Dahulu Sebelum Memilih Rujukan Internal`
                );
                return;
            }

            const rujukanInternal =
                this.listRujukanInternalByPeserta[index];

            if (rujukanInternal.layanan_tujuan.poli.FS_KD_POLI === "IRM") {
                // Rujukan fisioterapi
                this.form.tipe_rujukan = "04";
            } else {
                // Rujukan internal
                this.form.tipe_rujukan = "03";
            }
            this.form.no_surat_internal = rujukanInternal.FS_NO_SURAT;
            this.form.no_rujukan =
                    rujukanInternal.dataRujukanDetail.noSep;
            this.form.rujukan_detail = rujukanInternal.dataRujukanDetail;
            this.rujukanInternalSelected = rujukanInternal;
            this.activeNoRujukan = 1;

            const self = this;
            this.disableTglPeriksa = true;
            this.form.tgl_periksa = rujukanInternal.FD_TGL_PERIKSA;
            this.poliList = [];
            this.polis.forEach(function (poli) {
                if (
                        poli.FS_KD_POLI ==
                        rujukanInternal.layanan_tujuan.poli.FS_KD_POLI
                ) {
                        self.poliList.push(poli);
                 }
                });
            this.form.poli = rujukanInternal.layanan_tujuan.poli.FS_KD_POLI;
        },
        // Rujukan Lama
        setSuratKontrol(index) {
            if(this.form.tipe_rujukan != ""){
                const tipeRujukan = this.getTipeRujukanById(this.form.tipe_rujukan);
                alert(
                    `Reset ${tipeRujukan} Terlebih Dahulu Sebelum Memilih Surat Kontrol`
                );
                return;
            }

            const suratKontrol = this.listSuratKontrolByPeserta[index];
            if (suratKontrol.dataSuratKontrolDetail.sep.jnsPelayanan === "Rawat Jalan") {
                // Post Rawat Jalan
                this.form.tipe_rujukan = "02";
            } else {
                // Post Rawat Inap
                this.form.tipe_rujukan = "05";
            }
            this.form.no_rujukan = suratKontrol.dataRujukanDetail.noSep;
            this.form.no_surat_kontrol = suratKontrol.noSuratKontrol;
            this.form.rujukan_detail = suratKontrol.dataRujukanDetail;
            this.form.surat_kontrol_detail =
                suratKontrol.dataSuratKontrolDetail;
            this.suratKontrolSelected = suratKontrol;
            this.activeNoRujukan = 1;
            this.activeNoSuratKontrol = 1;

            const self = this;
            this.disableTglPeriksa = true;
            this.form.tgl_periksa = suratKontrol.tglRencanaKontrol;
            this.poliList = [];
            this.polis.forEach(function (poli) {
                if (
                    poli.FS_KD_POLI ==
                    suratKontrol.dataSuratKontrolDetail.poliTujuan
                ) {
                    self.poliList.push(poli);
                }
            });
        },
        // Rujukan Baru
        setRujukan(index) {
            if(this.form.tipe_rujukan != ""){
                const tipeRujukan = this.getTipeRujukanById(this.form.tipe_rujukan);
                alert(
                    `Reset ${tipeRujukan} Terlebih Dahulu Sebelum Memilih Rujukan Baru`
                );
                return;
            }
            const rujukan = this.listRujukanByPeserta[index];
            this.form.tipe_rujukan = "01";
            this.form.no_rujukan = rujukan.noKunjungan;
            this.form.rujukan_detail = rujukan;
            this.rujukanSelected = rujukan;
            this.activeNoRujukan = 1;

            const self = this;
            this.poliList = [];
            this.polis.forEach(function (poli) {
                if (poli.FS_KD_POLI == rujukan.poliRujukan.kode) {
                    self.poliList.push(poli);
                }
            });
            this.form.poli = rujukan.poliRujukan.kode;
        },
        resetRujukanInternal() {
            // this.form.tipe_rujukan = "";
            // this.form.no_rujukan = "";
            // this.form.rujukan_detail = "";
            // this.rujukanInternalSelected = "";
            // this.activeNoRujukan = 0;
            this.resetAll();
        },
        resetSuratKontrol() {
            // this.form.tipe_rujukan = "";
            // this.form.no_rujukan = "";
            // this.form.no_surat_kontrol = "";
            // this.form.rujukan_detail = "";
            // this.form.surat_kontrol_detail = "";
            // this.suratKontrolSelected = "";
            // this.activeNoRujukan = 0;
            // this.activeNoSuratKontrol = 0;
            this.resetAll();
        },
        resetRujukan() {
            // this.form.tipe_rujukan = "";
            // this.form.no_rujukan = "";
            // this.form.rujukan_detail = "";
            // this.rujukanSelected = "";
            // this.activeNoRujukan = 0;
            this.resetAll();
        },
        resetAll(){
            this.form.tipe_rujukan = "";
            this.form.no_rujukan = "";
            this.form.no_surat_kontrol = "";
            this.form.rujukan_detail = "";
            this.form.surat_kontrol_detail = "";
            this.suratKontrolSelected = "";
            this.rujukanInternalSelected = "";
            this.rujukanSelected = "";
            this.activeNoRujukan = 0;
            this.activeNoSuratKontrol = 0;
            this.disableTglPeriksa = false;
        },
        getTipeRujukanById(id){
            switch (id) {
                case '01':
                    return 'Rujukan Baru';
                    break;
                case '02':
                    return 'Rujukan Kontrol - Post Rawat Jalan';
                    break;
                case '03':
                    return 'Rujukan Internal';
                    break;
                case '04':
                    return 'Rujukan Internal - Fisioterapi';
                    break;
                case '05':
                    return 'Rujukan Kontrol - Post Rawat Inap';
                    break;
                default:
                    break;
            }
        }
    },
};
</script>
